class CreateNewElement {
    constructor() {}

    input = settings => {
        let input = document.createElement('input');

        input.setAttribute('status', settings.status);
        input.setAttribute('type', settings.type);
        input.setAttribute('name', settings.name);
        input.setAttribute('id', settings.id);
        input.setAttribute('value', settings.value);
        input.setAttribute('data-type', settings.dataType);

        settings.classes.forEach(newClass => {
            input.classList.add(newClass);
        });

        return input;
    }

    div = settings => {
        let div = document.createElement('div');

        div.setAttribute('id', settings.id);

        settings.classes.forEach(newClass => {
            div.classList.add(newClass);
        });

        return div;
    }

    label = settings => {
        let label = document.createElement('label');

        label.setAttribute('for', settings.id);

        settings.classes.forEach(newClass => {
            label.classList.add(newClass);
        });

        return label;
    }

    custom = settings => {
        let element = document.createElement(settings.elementType);

        element.setAttribute('id', settings.id);
        element.appendChild(settings.text);

        settings.classes.forEach(newClass => {
            element.classList.add(newClass);
        });

        return element;
    }

    text = text => {
        return document.createTextNode(text);
    }
}
